export const formatDecimal = (v, precision = 2) => {
  if (v === undefined || v === null || v === '-') return v;
  const n = parseFloat(v);
  return Number.isNaN(n) ? v : n.toFixed(precision);
};

export const formatCurrency = (value) => `R${Number(value || 0).toFixed(2)}`;

export const transformConsolidatedTotals = (data) => {
    return {
      "Payout": {
        main: data.consolidated_totals.total_payout,
        diff: data.consolidated_totals.payout_diff,
        brackets: data.consolidated_totals.previous_payout
      },
      "Total Corporate Earnings": {
        main: data.consolidated_totals.total_corporate_earnings,
        diff: data.consolidated_totals.corporate_earnings_diff,
        brackets: data.consolidated_totals.previous_corporate_earnings
      },
      "Trip Turnover": {
        main: data.consolidated_totals.total_trips,
        diff: data.consolidated_totals.trips_diff,
        brackets: data.consolidated_totals.previous_trips
      },
    };
  };

export const transformFleetTotals = (data) => {
    const cd = data.fleet_overview.company_data;
    return {
        "Payout": {
        main: parseFloat(cd.total_payout) || 0,
        diff: "-",
        brackets: "-"
        },
        "Access to Site": {
        main: parseFloat(cd.total_access_to_site) || 0,
        diff: "-",
        brackets: "-"
        },
        "Deduction": {
        main: parseFloat(cd.total_deduction) || 0,
        diff: "-",
        brackets: "-"
        },
        // "Running Balance": {
        //   main: data.fleet_overview.company_data.total_balance,
        //   diff: "-",
        //   brackets: "-"
        // },
    };
};

export const transformFleetTrips = (data) => {
    return {
        "Total Trips": { main: data.fleet_overview.total_trips, diff: data.fleet_overview.trip_diff },
        ...Object.fromEntries(
        data.fleet_overview.trip_breakdown.map(([name, count]) => [
            name,
            { main: count, diff: null },
        ])
        ),
    };
};

